export class Materia {
  idMateria: number = null;
  dataDivulgacao: Date = null;
  indImprime: string = null;
  titulo: string = null;
  //fkTipomateria: number = null;
  //fkUnidadepublicadora: number = null;
  //fkSistemas: number = null;
  dataGravacao: Date = null;
  versao: string = null;
  idDejt: number = null;
  caderno: string = null;
  pagina: number = null;
  situacao: number = null;
  /*NULO - ainda não foi processado
0 - Gerado o arquivo XML.
1 - PUBLICAÇÃO LIBERADA
2 - CANCELADA
3 - PUBLICADA*/
  dataPublicacao: Date = null;
  tpCaderno: string = null;

  constructor(d?) {
    this.idMateria = d.idMateria ? d.idMateria : null;
    this.dataDivulgacao = d.dataDivulgacao ? d.dataDivulgacao : null;
    this.indImprime = d.indImprime ? d.indImprime : null;
    this.titulo = d.titulo ? d.titulo : null;
    //this.fkTipomateria = d.fkTipomateria      ? new Tipomateria(d.fkTipomateria)      : null;
    //this.fkUnidadepublicadora = d.fkUnidadepublicadora      ? new Unidadepublicadora(d.fkUnidadepublicadora)      : null;
    //this.fkSistemas = d.fkSistemas ? new Sistema(d.fkSistemas) : null;
    this.dataGravacao = d.dataGravacao ? d.dataGravacao : null;
    this.versao = d.versao ? d.versao : null;
    this.idDejt = d.idDejt ? d.idDejt : null;
    this.caderno = d.caderno ? d.caderno : null;
    this.pagina = d.pagina ? d.pagina : null;
    this.situacao = d.situacao ? d.situacao : null;
    this.dataPublicacao = d.dataPublicacao ? d.dataPublicacao : null;
    this.tpCaderno = d.tpCaderno ? d.tpCaderno : null;
  }
}
